/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreateUserRequest {
  login?: string | null;
  firstName: string;
  lastName?: string | null;
  middleName?: string | null;
  email: string;
  emailConfirmed?: boolean;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  userTypeId?: number | null;
  isAgreementAcceptanceRequired?: boolean;
  isResetPasswordLinkSendingRequired?: boolean;
  roleIds?: Array<string> | null;
  tenantIds?: Array<string> | null;
}
